// ============================================================================
// Service hero — SCROLL button
// ----------------------------------------------------------------------------
// The original inline JS targeted an element ID that didn't exist on this
// page (it was a copy-paste from another template). Scroll to the FAQ
// accordion section, which is the next section below the hero.
// ============================================================================

document.addEventListener("DOMContentLoaded", function () {
  const scrollButton = document.querySelector(".service-hero__scroll");
  const target = document.querySelector(".services-faq");

  if (!scrollButton || !target) return;

  scrollButton.addEventListener("click", function () {
    target.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  });
});
